"use client"

import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { HotelPromotion } from "@/lib/redux/features/hotel/type"
import { Col, Flex, Row, Space, Tag } from "antd"
import { FC } from "react"
import { useTranslation } from "react-i18next"

type HotelPriceProps = {
  price?: number,
  promotionDetail?: HotelPromotion,
  variant?: "default" | "card" | "card-mobile" | "detail-card",
}

const HotelPrice: FC<HotelPriceProps> = ({ price = 0, promotionDetail, variant = "default" }) => {
  const { getFormatCurrency } = useTETranslation()
  const { t } = useTranslation()

  const savingAmount = Number(promotionDetail?.savingAmount) || 0
  const hasPromo = savingAmount > 0 && price > 0
  const originalPrice = hasPromo ? price + savingAmount : 0

  if (variant === "card-mobile") {
    return (
      <Flex vertical align="flex-start" gap={2} className="hotels__list--item-pricing hotels__list--item-pricing--mobile">
        {hasPromo && (
          <Text delete type="secondary" className="hotels__list--item-pricing-original-text">
            {getFormatCurrency(originalPrice)}
          </Text>
        )}
        <Title className="hotels__list--item-price" level={3} style={{ margin: 0 }}>
          {getFormatCurrency(price)}
        </Title>
        <Text type="secondary" className="hotels__list--item-price-note">
          {t("hotel.price_includes_fee_tax")}
        </Text>
        {hasPromo && (
          <Tag variant="filled" className="hotels__list--item-saving">
            <Text>
              {t("hotel.save_label")} <Text strong>{getFormatCurrency(savingAmount)}</Text>
            </Text>
          </Tag>
        )}
      </Flex>
    )
  }

  if (variant === "card" || variant === "detail-card") {
    return (
      <Flex vertical align="flex-end" gap={4} className="hotels__list--item-pricing hotels__list--item-pricing--desktop">
        {hasPromo && (
          <Text delete type="secondary" className="hotels__list--item-pricing-original-text">
            {getFormatCurrency(originalPrice)}
          </Text>
        )}
        <Title className="hotels__list--item-price" level={3} style={{ margin: 0 }}>
          {getFormatCurrency(price)}
        </Title>
        <Text type="secondary" className="hotels__list--item-price-note">
          {t(variant === "detail-card" ? "hotel.price_per_night_includes_fee_tax" : "hotel.price_includes_fee_tax")}
        </Text>
        {hasPromo && (
          <Tag variant="filled" className="hotels__list--item-saving">
            <Space orientation="vertical" size={2} align="end">
              <Text className="hotels__list--item-saving-label">{t("hotel.save_label")}</Text>
              <Text strong className="hotels__list--item-saving-amount">
                {getFormatCurrency(savingAmount)}
              </Text>
            </Space>
          </Tag>
        )}
      </Flex>
    )
  }

  return (
    <Col>
      {hasPromo && (
        <Row justify="end">
          <Title type="secondary" level={5} delete>
            {getFormatCurrency(originalPrice)}
          </Title>
        </Row>
      )}
      <Row justify="end">
        <Title className="hotels__list--item-price" level={4}>
          {getFormatCurrency(price)}
        </Title>
      </Row>
    </Col>
  )
}

export default HotelPrice
